module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_fails.js
// module id = 8
// module chunks = 0